import React from 'react';

import useMobile from '@/hooks/use-mobile';

import { TariffsTableDesktop } from './TariffsTableDesktop';
import { TariffsTableMobile } from './TariffsTableMobile';
import { TariffsTableProps } from './types';

export default function TariffsTable(props: TariffsTableProps): JSX.Element {
	const { isMobile } = useMobile();

	return isMobile ? <TariffsTableMobile {...props} /> : <TariffsTableDesktop {...props} />;
}
